<template>
    <div>
        <b-input-group :size="size" :class="inputGroupClass">
            <b-form-input 
                readonly 
                ref="clipboard-copy-input"
                :id="idInput" 
                :value="copyText"
            ></b-form-input>
            <b-input-group-append>
                <b-button
                    :id="idInput + '-button'" 
                    :variant="buttonVariantCurrent" 
                    :disabled="disabled"
                    @click="copyTextFunction"
                >
                    <b-icon icon="clipboard" class="mr-1"></b-icon>
                    {{ buttonTextCurrent }}
                </b-button>
            </b-input-group-append>
        </b-input-group>
    </div>
</template>

<script>
export default {
    name: 'BaseClipboardCopyInput',
    props: {
        copyText: {
            type: String,
            required: false,
        },
        size: { // size of overall b-input-group
            type: String,
            default: 'md'
        },
        idInput: {
            type: String,
            default: 'clipboard-copy-field'
        },
        buttonVariantStart: {
            type: String,
            default: 'primary'
        },
        buttonVariantSuccess: {
            type: String,
            default: 'success'
        },
        buttonTextStart: {
            type: String,
            default: 'Click to Copy'
        },
        buttonTextSuccess: {
            type: String,
            default: 'COPIED!'
        },
        inputGroupClass: {
            type: String,
            required: false,
        },
        disabled: { // will disable the copy button
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            buttonVariantCurrent: this.buttonVariantStart,
            buttonTextCurrent: this.buttonTextStart
        }
    },
    methods: {
        copyTextFunction: function() {
            /*
            let stringToCopy = document.getElementById(selector);
            let copyButton = document.getElementById(selector + '-button');
            stringToCopy.setAttribute('type', 'text');    // 不是 hidden 才能複製
            stringToCopy.select();
            */

            this.$refs['clipboard-copy-input'].select();

            try {
                //var successful = document.execCommand('copy');
                document.execCommand('copy');
                this.buttonVariantCurrent = this.buttonVariantSuccess;
                this.buttonTextCurrent = this.buttonTextSuccess;
            } catch (err) {
                console.log('Unable to copy text');
                // could potentially show message here for Ctrl + C to user
            }
            // Don't need to change text because you're just going to show tooltip after clicking
            setTimeout(() => {
                this.buttonVariantCurrent = this.buttonVariantStart;
                this.buttonTextCurrent = this.buttonTextStart;
            }, 1500);

            /* unselect the range */
            // maybe best to leave text highlighted so user knows it was selected
            //stringToCopy.setAttribute('type', 'hidden')
            //window.getSelection().removeAllRanges()
        }
    },

}
</script>

<style>

</style>